import { CategoryBannerCustomer } from "../../client/swaggerClient";
import { LandingPageBanner } from "../../components/_common/LandingPageComponent/LandingPage.types";
export type CategoryBannerData = {
  adUnit: string;
  name: string;
}

export const getCategoryBannerData = (name: string): CategoryBannerData | null => {
  switch (name) {
    case CategoryBannerCustomer.Sisilla:
      return {
        adUnit: '/61270011/SZP_Gepek_kategoria',
        name: 'div-SZP_Gepek_kategoria'
      };
    case CategoryBannerCustomer.Femgepszer:
      return {
        adUnit: '/61270011/SZP_szerszamgep_femipar_kategoria',
        name: 'div-SZP_szerszamgep_femipar_kategoria'
      }
    case LandingPageBanner.CategoryAlatt:
      return {
        adUnit: '/61270011/szp_landing_categoryalatt',
        name: 'div-szp_landing_categoryalatt'
      }
    default:
      return null
  }
}